<template>
	<div class="mt-4">
		<div class="space-y-5">
			<div v-for="(task, n) in modifiedGoal?.tasks || []" :key="n" class="flex w-full">
				<div class="mr-2">
					<button class="checklistItem mb-0 py-0" :class="[{'checked' : task.is_completed}]" @click="() => emit('toggleComplete', task)">
						<div class="checkMarker">
							<church-icon icon="check" />
						</div>
					</button>
				</div>

				<div class="flex-1 text-left">
					<input v-if="editMode" type="text" v-model="task.task_name" placeholder="Task Name"
						:class="[{'line-through opacity-60' : task.is_completed}]"
						class="w-full focus:outline-none" @blur="emit('updateTasks', task)" />
					<div v-else :class="['leading-tight', {'line-through opacity-60' : task.is_completed}]">{{ task?.task_name || '' }}</div>
					<div v-if="task.is_completed" class="text-sm mb-2.5 mt-2 flex items-center justify-end">
						<span v-if="completedByAvatar(task)" class="block w-6 h-6 rounded-full overflow-clip border border-white bg-white mr-2">
							<img :src="completedByAvatar(task)" alt="" class="w-full h-full">
						</span>
						<span class="font-bold ">{{ completedByName(task) }}</span> 
						<span class="text-gray-1 "> - {{ formatDate(task?.date_completed) }}</span>
					</div>
				</div>

				<div v-if="editMode && localGoal?.tasks?.length > 1 && task.is_completed == false">
					<button @click="() => (emit('toDeleteTaskData', task), emit('showDeleteTaskPop', true))" class="ml-2">
						<church-icon class="!text-red !w-5 !h-5" icon="x-mark"></church-icon>
					</button>
				</div>
			</div>

		</div>


		<div v-if="!noAddTask" class="border-t border-gray-2 pt-2 mt-4">
			<button @click="() => emit('addMoreTask')"
				class="flex items-center justify-center w-full text-gray-1 text-sm"><church-icon class="!w-5 mr-2"
					icon="plus-circle" /> Add Task</button>
		</div>
	</div>
</template>

<script setup >
/* ========== UTILS ======== */
import StringParser from '@/helpers/stringParser';
import _ from 'lodash';
import { defineProps, defineEmits, ref, watch, computed } from 'vue';

/* ======== PROPS ======= */
const props = defineProps(
	{ 
		goal: {type: Object, default: () => {}},
		completedByName: {type: Function, default: () => {}},
		formatDate: {type: Function, default: () => {}},
		noAddTask: {type: Boolean, default: false},
		editMode: {type: Boolean, default: false},
		assignedUsers : {type: Array, default : () => []}
	}
)

/* ======== STATES ======== */
const localGoal = ref(props.goal)

/* ======== COMPUTED ======== */
/**
 * Modified tasks
 */
const modifiedGoal = computed({
	get: () => {
		let goal = localGoal.value
		goal.tasks = goal.tasks.sort((a, b) =>  a.is_completed - b.is_completed)
		return goal
	},
	set: (val) => {
		localGoal.value = val
	}
})

/* ============= METHODS ====== */

/**
 * Get avatar of the user who completed the task
 * @param {Object} task 
 */
const completedByAvatar = (task) => {
	if(!task?.completed_by) return ''
	if(task) {
		let user = ''
		StringParser.extractUrl({string : task?.completed_by?.user_avatar, callback: url =>  user = _.last(url)})
		return user
	} return ''
}

/* ======== EMITS ========= */
const emit = defineEmits(['toggleComplete', 'addMoreTask', 'toDeleteTaskData', 'showDeleteTaskPop', 'goal:update', 'updateTasks'])


/* ======== WATCHERS ======== */
watch(() => localGoal.value, (newVal) => {
	emit('goal:update', newVal)
})
</script>
